import { useSelector } from 'react-redux';

import { useInfrastructureLayer } from './useInfrastructureLayer';
import { useInfrastructurePinsFetching } from './useInfrastructurePinsFetching';
import { selectIsInfrastructureOnMapEnabled } from '../../../selectors';

interface IUseInfrastructureParams {
  ymaps: YMaps.IYMaps;
  map: YMaps.Map;
}

export function useInfrastructure({ ymaps, map }: IUseInfrastructureParams): void {
  const isEnabled = useSelector(selectIsInfrastructureOnMapEnabled);

  useInfrastructurePinsFetching({ enabled: isEnabled });
  useInfrastructureLayer({ ymaps, map, enabled: isEnabled });
}
